/**
 * Created by ivo on 12.05.17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import t from '../trans';
import {FormGroup} from "./Bootstrap";
import {PageActionActions, SubmitAction} from "../services/PageAction";

class PasswordForm extends React.Component {
    static propTypes = {
        /**
         * Form fields validation messages
         */
        validation: PropTypes.object,
        /**
         * If form input fields and button should be disabled
         */
        disabled: PropTypes.bool,
        /**
         * Default value for e-mail address field
         */
        email: PropTypes.string,
        password: PropTypes.string,
        code: PropTypes.string,
        newPassword: PropTypes.string,
        newPassword2: PropTypes.string,
        /**
         * If e-mail field should be read-only
         */
        lockEmail: PropTypes.bool,
        /**
         * Should password form contain also two-factor code field
         */
        askCode: PropTypes.bool,
        /**
         * Do not ask old password
         */
        noPassword: PropTypes.bool,
        /**
         * Do not ask new password (i.e. ask only code)
         */
        noNewPassword: PropTypes.bool,
        /**
         * Called when user changes field value (email, password, code, newPassword, newPassword2)
         *  onChange(field, newValue)
         */
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        disabled: false,
        lockEmail: false,
        askCode: false,
        noPassword: false,
        noNewPassword: false
    };

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(e) {
        e.preventDefault();
        if (this.props.onChange) this.props.onChange(e.target.name, e.target.value);
    }

    onSubmit(e) {
        e.preventDefault();
        PageActionActions.callAction(new SubmitAction());
        return false;
    }

    render() {
        return (
            <form className="form-horizontal" onSubmit={this.onSubmit}>
                <fieldset disabled={this.props.disabled}>
                    {
                        (this.props.lockEmail && !this.props.email) ? null :
                            <FormGroup label={t("E-mail")} inputId="email" validation={this.props.validation}>
                                {
                                    this.props.lockEmail ?
                                        <p className="form-control-static" id="email">{this.props.email}</p> :
                                        <input type="email" className="form-control" name="email" id="email"
                                               value={this.props.email} onChange={this.onChange} required={true}/>
                                }
                            </FormGroup>
                    }
                    {
                        this.props.noPassword ?
                            null :
                            <FormGroup label={t("Password")} inputId="password" validation={this.props.validation}>
                                <input type="password" className="form-control" name="password" id="pasword" autoComplete="off"
                                       value={this.props.password} onChange={this.onChange} required={true}/>
                            </FormGroup>
                    }
                    {
                        this.props.askCode ?
                            <FormGroup label={t("Verification Code")} inputId="code" validation={this.props.validation}>
                                <input type="text" className="form-control" name="code" autocomplete="off" id="code"
                                       value={this.props.code} onChange={this.onChange} required={true}/>
                            </FormGroup> :
                            null
                    }
                    {
                        this.props.noNewPassword ?
                            null :
                            <FormGroup label={t("New Password")} inputId="newPassword"
                                       validation={this.props.validation}>
                                <input type="password" className="form-control" name="newPassword" id="newPassword" autoComplete="off"
                                       value={this.props.newPassword} onChange={this.onChange} required={true}/>
                            </FormGroup>
                    }
                    {
                        this.props.noNewPassword ?
                            null :
                            <FormGroup label={t("Confirm New Password")}  inputId="newPassword2" validation={this.props.validation}>
                                <input type="password" className="form-control" name="newPassword2" id="newPassword2" autoComplete="off"
                                    value={this.props.newPassword2} onChange={this.onChange} required={true}/>
                            </FormGroup>

                    }
                    <input type="submit" hidden="true"/>
                </fieldset>
            </form>
        );
    }
}

export default PasswordForm;
